import {TripCollection} from "../Trip";
import sighisoara from "../../../assets/child/sighisoara.jpg";

const dayChildSighi: TripCollection = {
    imageSrc: sighisoara,
    trips: [
        {
            name: "4.1. Sighișoara I",
            route: "Braşov – Sighişoara – Viscri – Rupea – Braşov",
            days: [
                [
                    {
                        locationName: "Turnul cu Ceas",
                    },
                    {
                        locationName: "Tur Centrul Istoric",
                    },
                    {
                        locationName: "Biserica Evanghelică Fortificată Viscri",
                    },
                    {
                        locationName: "Plimbare prin satul Viscri",
                    },
                    {
                        locationName: "Cetatea Rupea",
                    },
                ]
            ],
            notes: "Programul propune o incursiune în patrimoniul istoric și rural al Transilvaniei, punând în valoare unele dintre cele mai bine conservate obiective medievale. Vizita începe cu Turnul cu Ceas din Sighișoara, simbol al orașului și punct de belvedere ce oferă o perspectivă amplă asupra cetății. Turul pietonal al centrului istoric, inclus în patrimoniul mondial UNESCO, permite descoperirea străzilor medievale, a clădirilor istorice și a atmosferei autentice care definesc acest oraș-cetate. Experiența continuă în satul Viscri, unde vizitarea Bisericii Evanghelice Fortificate, monument UNESCO, este completată de o plimbare relaxantă prin sat, prilej de a admira arhitectura tradițională săsească și ritmul de viață specific zonei. Programul se încheie cu vizita Cetății Rupea, una dintre cele mai vechi și spectaculoase fortificații din Transilvania, amplasată pe un deal vulcanic și oferind panorame impresionante asupra împrejurimilor."
        },
        {
            name: "4.2. Sighișoara II",
            route:
                "Braşov – Şoard – Sighişoara – Rupea – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Turnul cu Ceas",
                        },
                        {
                            locationName: "Tur Centrul Istoric",
                        },
                        {
                            locationName: "Herbarium – Şura cu Plante",
                        },
                        {
                            locationName: "Cetatea Rupea",
                        },
                    ]
                ],
            notes:
                `Programul oferă o incursiune în patrimoniul istoric și natural al Transilvaniei, combinând obiective culturale cu experiențe inedite. Vizita începe cu Turnul cu Ceas din Sighișoara, simbol al orașului și punct de belvedere ce oferă o perspectivă panoramică asupra cetății. Turul pietonal al centrului istoric permite explorarea străzilor medievale, a clădirilor istorice și a atmosferei autentice a acestui oraș-cetate. Experiența continuă cu o vizită la Herbarium – Șura cu Plante din Șoard, un spațiu dedicat cunoașterii lumii vegetale și frumuseții naturii, ideal pentru toți cei pasionați de botanica și mediu. Excursia se încheie cu Cetatea Rupea, una dintre cele mai vechi și spectaculoase fortificații din Transilvania, situată pe un deal vulcanic și oferind panorame impresionante asupra împrejurimilor. Herbarium - Elevii vor fi ghidați pas cu pas în procesul creativ de
            producție a propriilor pastile de ceai. De la selectarea
            ingredientelor naturale și aromele preferate, la amestecarea
            și modelarea pastilelor, fiecare participant va avea ocazia
            să își pună imaginația la treabă și să creeze propriul său
            amestec unic de ceai. În timp ce își construiesc propriile
            creații, elevii vor învăța despre proprietățile și beneficiile
            plantelor, precum și despre procesul de fabricație a
            ceaiului. Acest atelier interactiv promite să fie o experiență
            educativă și distractivă pentru toți participanții!`
        }
        ,
        {
            name: "4.3. Sighișoara III",
            route:
                "Braşov – Sighişoara – Odorheiul Secuiesc – Rupea – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Turnul cu Ceas",
                        },
                        {
                            locationName: "Tur Centrul Istoric",
                        },
                        {
                            locationName: "Parcul Mini Transilvania",
                        },
                        {
                            locationName: "Cetatea Rupea",
                        },
                    ]
                ],
            notes:
                "Programul propune o călătorie fascinantă prin istoria și cultura Transilvaniei, combinând obiective medievale cu experiențe interactive. Vizita începe cu Turnul cu Ceas din Sighișoara, simbol al orașului și punct de belvedere ce oferă panorame impresionante asupra cetății. Turul pietonal al centrului istoric permite descoperirea străzilor medievale, a clădirilor emblematice și a atmosferei autentice care definește acest oraș-cetate. Traseul continuă la Parcul Mini Transilvania din Odorheiul Secuiesc, un spațiu interactiv unde monumentele și clădirile reprezentative ale regiunii sunt reproduse la scară redusă, oferind o experiență educativă și distractivă pentru toate vârstele. Excursia se încheie cu vizita la Cetatea Rupea, o fortificație impunătoare situată pe un deal vulcanic, de unde se deschide o panoramă spectaculoasă asupra împrejurimilor."
        }
        ,
        {
            name: "4.4. Sighișoara IV",
            route:
                "Braşov – Odorheiul Secuiesc – Şoard – Sighişoara – Braşov",
            days:
                [
                    [
                        {
                            locationName: "Parcul Mini Transilvania",
                        },
                        {
                            locationName: "Herbarium – Şura cu Plante",
                        },
                        {
                            locationName: "Turnul cu Ceas",
                        },
                        {
                            locationName: "Tur Centrul Istoric",
                        },
                    ]
                ],
            notes:
                `Programul combină experiențe educative și culturale, oferind o incursiune completă în istoria și natura Transilvaniei. Vizita începe la Parcul Mini Transilvania din Odorheiul Secuiesc, unde monumentele și clădirile reprezentative ale regiunii sunt reproduse la scară redusă, oferind o experiență interactivă și captivantă pentru toate vârstele. Urmează Herbarium – Șura cu Plante din Șoard, un spațiu dedicat cunoașterii lumii vegetale și frumuseții naturii, ideal pentru iubitorii de botanică. Excursia continuă la Sighișoara cu Turnul cu Ceas, simbol al orașului, și turul pietonal al centrului istoric, unde vizitatorii descoperă străzi medievale, clădiri emblematice și atmosfera autentică a acestui oraș-cetate. Herbarium - Elevii vor fi ghidați pas cu pas în procesul creativ de
            producție a propriilor pastile de ceai. De la selectarea
            ingredientelor naturale și aromele preferate, la amestecarea
            și modelarea pastilelor, fiecare participant va avea ocazia
            să își pună imaginația la treabă și să creeze propriul său
            amestec unic de ceai. În timp ce își construiesc propriile
            creații, elevii vor învăța despre proprietățile și beneficiile
            plantelor, precum și despre procesul de fabricație a
            ceaiului. Acest atelier interactiv promite să fie o experiență
            educativă și distractivă pentru toți participanții!`
        }
        ,
    ]
}

export default dayChildSighi;